export default "__VITE_ASSET__02dcbe2e__"